var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMultiLinksIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6272_261679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.16667 7.00032H26.8333C27.1428 7.00032 27.4395 6.8774 27.6583 6.65861C27.8771 6.43982 28 6.14308 28 5.83366C28 5.52424 27.8771 5.22749 27.6583 5.0087C27.4395 4.78991 27.1428 4.66699 26.8333 4.66699H8.16667C7.85725 4.66699 7.5605 4.78991 7.34171 5.0087C7.12292 5.22749 7 5.52424 7 5.83366C7 6.14308 7.12292 6.43982 7.34171 6.65861C7.5605 6.8774 7.85725 7.00032 8.16667 7.00032Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8333 12.833H8.16667C7.85725 12.833 7.5605 12.9559 7.34171 13.1747C7.12292 13.3935 7 13.6903 7 13.9997C7 14.3091 7.12292 14.6058 7.34171 14.8246C7.5605 15.0434 7.85725 15.1664 8.16667 15.1664H26.8333C27.1428 15.1664 27.4395 15.0434 27.6583 14.8246C27.8771 14.6058 28 14.3091 28 13.9997C28 13.6903 27.8771 13.3935 27.6583 13.1747C27.4395 12.9559 27.1428 12.833 26.8333 12.833Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8333 21H8.16667C7.85725 21 7.5605 21.1229 7.34171 21.3417C7.12292 21.5605 7 21.8573 7 22.1667C7 22.4761 7.12292 22.7728 7.34171 22.9916C7.5605 23.2104 7.85725 23.3333 8.16667 23.3333H26.8333C27.1428 23.3333 27.4395 23.2104 27.6583 22.9916C27.8771 22.7728 28 22.4761 28 22.1667C28 21.8573 27.8771 21.5605 27.6583 21.3417C27.4395 21.1229 27.1428 21 26.8333 21Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 8.16666C3.622 8.16666 4.66667 7.12199 4.66667 5.83333C4.66667 4.54467 3.622 3.5 2.33333 3.5C1.04467 3.5 0 4.54467 0 5.83333C0 7.12199 1.04467 8.16666 2.33333 8.16666Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 16.3337C3.622 16.3337 4.66667 15.289 4.66667 14.0003C4.66667 12.7117 3.622 11.667 2.33333 11.667C1.04467 11.667 0 12.7117 0 14.0003C0 15.289 1.04467 16.3337 2.33333 16.3337Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 24.4997C3.622 24.4997 4.66667 23.455 4.66667 22.1663C4.66667 20.8777 3.622 19.833 2.33333 19.833C1.04467 19.833 0 20.8777 0 22.1663C0 23.455 1.04467 24.4997 2.33333 24.4997Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6272_261679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiLinksIcon);
export default __webpack_public_path__ + "static/media/multi-links-icon.efc5cfb550ff3af32d356a0172610b83.svg";
export { ForwardRef as ReactComponent };